import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import aboutbanner from '../Assets/Images/banner1.avif';
import team18 from '../Assets/Images/team18.jpg';
import team1 from '../Assets/Images/team1.jpg';
import team2 from '../Assets/Images/team2.jpg';

import { Helmet } from "react-helmet";

export default function NewsEvents() {
  const newsArticles = [
    {
      title: "Security Services Expansion",
      description:
        "Sumanik Security and Allied Services Pvt Ltd is expanding its operations across India, offering enhanced security solutions for enterprises and individuals.",
      newsimage: team18,
    },
    {
      title: "New Certification Received",
      description:
        "We are proud to announce that we have obtained the latest PASARA License and statutory approvals to ensure complete compliance.",
      newsimage: team1,
    },
    {
      title: "Client Appreciation",
      description:
        "Our team was recognized by a leading hotel chain for providing dedicated security services consistently over five years.",
      newsimage: team2,
    },
  ];

  return (
    <>
      <div className="mainnav">

      <Helmet>
      <title>News & Events | Sumanik Security And Allied Services Pvt Ltd</title>
      <meta
        name="description"
        content="Stay updated with the latest news, certifications, events, and achievements from Sumanik Security — a leading name in India’s security services sector."
      />
      <meta
        name="keywords"
        content="Sumanik Security News, Security Events India, PASARA License Update, Security Workshops, Cybersecurity Seminars, Security Expo, Company Announcements"
      />
      <meta name="author" content="Sumanik Security And Allied Services Pvt Ltd" />
      <meta property="og:title" content="Latest News & Events | Sumanik Security Pvt Ltd" />
      <meta
        property="og:description"
        content="Explore updates on operations, certifications, client appreciation, and upcoming security awareness events from Sumanik Security."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.sumaniksecurity.com/news-events" />
      <meta property="og:image" content="https://www.sumaniksecurity.com/images/news-events-og.jpg" />
    </Helmet>

        {/* Hero Banner */}
        <div className="about-banner position-relative text-white">
          <img src={aboutbanner} alt="About Banner" className="aboutbanner-image w-100" />
          <div className="maindesc position-absolute top-50 start-50 translate-middle text-center px-3">
            <h2 className="fw-bold">
              News & Events – Sumanik Security and Allied Services Pvt Ltd
            </h2>
          </div>
        </div>

        {/* Latest News */}
        <section className="latest-news py-4 bg-light">
          <Container>
            <h2 className="Mainhead mb-4 text-center">Latest News</h2>
            <Row>
              {newsArticles.map((news, index) => (
                <Col md={4} key={index} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <Card.Img variant="top" src={news.newsimage} style={{ height: '250px', objectFit: 'cover' }} />
                    <Card.Body>
                      <Card.Title>{news.title}</Card.Title>
                      <Card.Text>{news.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Upcoming Events */}
        <section className="upcoming-events py-1">
          <Container>
            <h2 className="Mainhead mb-4 text-center">Upcoming Events</h2>
            <Row>
              <Col md={6} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>Security Awareness Workshop</Card.Title>
                    <Card.Text>
                      Join our interactive workshop designed to promote awareness on personal and workplace security practices.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>Cybersecurity for Small Businesses</Card.Title>
                    <Card.Text>
                      A seminar for startups and small businesses to understand essential cybersecurity measures with expert insights.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Past Events */}
        <section className="past-events py-3 bg-light">
          <Container>
            <h2 className="Mainhead mb-4 text-center">Past Events</h2>
            <Row>
              <Col md={6} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>Security Solutions Expo 2025</Card.Title>
                    <Card.Text>
                      We showcased our innovative security technologies at the 2025 Expo, engaging with industry leaders and partners.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>National Security Conference</Card.Title>
                    <Card.Text>
                      Our experts shared strategies on modern industrial security management at the national-level conference.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

       
      </div>
    </>
  );
}
